import React, { useRef, useState } from 'react';
import { GiEarthAsiaOceania } from 'react-icons/gi';
import { MdChevronLeft } from 'react-icons/md';
import { CSSTransition } from 'react-transition-group';
import AnimateHeight from 'react-animate-height';
import { Button, Typography } from 'amphitheatre';

import Item, {
  Content,
  Label,
  FileIcon,
  Icon,
  Wrapper,
} from './PIGIDownload.styled';

const { Header, Paragraph } = Typography;

const PIGIDownload: React.FC = () => {
  const [expanded, setExpanded] = useState(false);
  const iconRef = useRef(null);

  function onClick(e: React.MouseEvent<HTMLDivElement>) {
    setExpanded(!expanded);
  }

  return (
    <Wrapper>
      <Item className={expanded ? 'expanded' : ''} onClick={onClick}>
        <FileIcon>
          <GiEarthAsiaOceania />
        </FileIcon>

        <Label>P.I.G.I Files</Label>
        <CSSTransition
          nodeRef={iconRef}
          in={expanded}
          timeout={125}
          classNames="rotate"
        >
          <Icon ref={iconRef}>
            <MdChevronLeft />
          </Icon>
        </CSSTransition>
      </Item>

      <AnimateHeight
        id="download-links"
        duration={125}
        height={expanded ? 'auto' : 0}
      >
        <Content>
          <Header level={3}>Windows Download</Header>
          <Paragraph>Windows version 7, 8.1 and 10 are supported!</Paragraph>
          <a href="https://downloads.saberdata.space/PIGI-64-Bit-Installer-0.8.75.exe">
            <Button className="primary" fill>
              Windows 64-Bit P.I.G.I v0.8.7.5
            </Button>
          </a>
          <br />
          <br />
          <a href="https://downloads.saberdata.space/PIGI-32-Bit-Installer-0.8.75.exe">
            <Button className="primary" fill>
              Windows 32-Bit P.I.G.I v0.8.7.5
            </Button>
          </a>
          <br />
          <br />
          <Header level={3}>Mac OS Download</Header>
          <a href="https://downloads.saberdata.space/PIGI/MacOS/Build/0.8.7.5/PIGI_Mac_0.8.75.dmg">
            <Button className="primary" fill>
              Mac OS
            </Button>
          </a>
        </Content>
      </AnimateHeight>
    </Wrapper>
  );
};

export default PIGIDownload;
